export const UserControllerFactory = ({
  userService,
}: {
  userService: IUserService;
}) => {
  const getUserBetaFeatures: IGetUserBetaFeaturesController = async (
    payload
  ) => {
    const userBetaFeature = await userService.getUserBetaFeatures(payload);
    return userBetaFeature;
  };

  const setUserBetaFeature: ISetUserBetaFeatureController = async (payload) => {
    return userService.setUserBetaFeature(payload);
  };

  const getPortalUserInfo: IGetPortalUserInfoController = async () => {
    return userService.getPortalUserInfo();
  };

  const updateUserInfo: IUpdateUserInfoController = async (payload) => {
    const userInfo = await userService.updateUserInfo(payload);
    return userInfo;
  };

  const signupUser: ISignupUserController = async (payload) => {
    const user = await userService.signupUser(payload);
    return user;
  };

  const autoBedExit: IAutoBedExitController = async (payload) => {
    const result = await userService.autoBedExit(payload);
    return result;
  };

  const getNasaTlxPreference: IGetNasaTlxPreferenceController = async () => {
    return userService.getNasaTlxPreference();
  };

  const submitNasaTlxPreference: ISubmitNasaTlxPreferenceController = async (
    payload
  ) => {
    return userService.submitNasaTlxPreference(payload);
  };

  return {
    getUserBetaFeatures,
    setUserBetaFeature,
    getPortalUserInfo,
    updateUserInfo,
    signupUser,
    autoBedExit,
    getNasaTlxPreference,
    submitNasaTlxPreference,
  };
};
